import React from 'react';
import { CheckCircle } from 'lucide-react';

export default function ActionedBadge() {
  return (
    <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold border bg-status-success-bg text-status-success border-status-success-border">
      <CheckCircle size={12} />
      Actioned
    </span>
  );
}
